<template>
<form id="contact-form" class="cf" @submit.prevent="submit">
    <input type="hidden" value="" id="loaded" name="page_loaded">
    <input type="hidden" value="" id="submitted" name="page_submitted">
    <main>
        <div class="grid-container">
            <div class="grid-x grid-padding-x">
                <div class="small-12 cell">
                    <h1>Contact Us</h1>
                </div>
                <div class="small-12 medium-6 cell">
                    <p><label for="description">Which of the following best describes you? <span>(Required)</span></label>
                        <select id="description" v-model="contact.description" class="form-style" name="description" >
                            <option value="" selected>Select:</option>
                            <option value="Property Owner">Property Owner</option>
                            <option value="Interested Buyer">Interested Buyer</option>
                            <option value="Local, State or Federal Agency Representative">Local, State or Federal Agency Representative</option>
                            <option value="Other">Other</option>
                        </select></p>
                        <p><label for="firstname">First Name: <span>(Required)</span></label>
                            <input id="firstname" type="text" name="firstname" v-model="contact.firstname" required></p>
                        <p><label for="lastname">Last Name: <span>(Required)</span></label>
                            <input id="lastname" type="text" name="lastname" v-model="contact.lastname" required></p>
                        <p><label for="email">Email: <span>(Required)</span></label>
                            <input id="email" type="email" name="email" v-model="contact.email" required></p>
                        <p><label for="phone">Phone:</label>
                            <input id="phone" type="text" name="phone" v-model="contact.phone"></p>
                </div>
                <div class="small-12 medium-6 cell">
                    <p><label for="propertyaddress">Address of the property in question: <span>(Required)</span></label>
                        <input id="propertyaddress" type="text" name="propertyaddress" v-model="contact.propertyaddress" required></p>
                    <div class="grid-container full">
                        <div class="grid-x grid-padding-x">
                            <div id="city-input" class="small-12 medium-5 large-4 cell">
                                <p><label for="city">City:</label>
                                    <input id="city" type="text" name="city" v-model="contact.city" ></p>
                            </div>
                            <div id="states-input" class="small-12 medium-4 large-4 cell">
                                <p><label for="states">State:</label>
                                    <select id="states" class="form-style" name="state" v-model="contact.state" >
                                        <option value>Select:</option>
                                        <option value="AL">AL</option>
                                        <option value="AK">AK</option>
                                        <option value="AR">AR</option>
                                        <option value="AZ">AZ</option>
                                        <option value="CA">CA</option>
                                        <option value="CO">CO</option>
                                        <option value="CT">CT</option>
                                        <option value="DC">DC</option>
                                        <option value="DE">DE</option>
                                        <option value="FL">FL</option>
                                        <option value="GA">GA</option>
                                        <option value="HI">HI</option>
                                        <option value="ID">ID</option>
                                        <option value="IL">IL</option>
                                        <option value="IA">IA</option>
                                        <option value="IN">IN</option>
                                        <option value="KS">KS</option>
                                        <option value="KY">KY</option>
                                        <option value="LA">LA</option>
                                        <option value="MA">MA</option>
                                        <option value="MD">MD</option>
                                        <option value="ME">ME</option>
                                        <option value="MI">MI</option>
                                        <option value="MN">MN</option>
                                        <option value="MS">MS</option>
                                        <option value="MO">MO</option>
                                        <option value="MT">MT</option>
                                        <option value="NC">NC</option>
                                        <option value="ND">ND</option>
                                        <option value="NE">NE</option>
                                        <option value="NH">NH</option>
                                        <option value="NJ">NJ</option>
                                        <option value="NM">NM</option>
                                        <option value="NV">NV</option>
                                        <option value="NY">NY</option>
                                        <option value="OH">OH</option>
                                        <option value="OK">OK</option>
                                        <option value="OR">OR</option>
                                        <option value="PA">PA</option>
                                        <option value="RI">RI</option>
                                        <option value="SC">SC</option>
                                        <option value="SD">SD</option>
                                        <option value="TN">TN</option>
                                        <option value="TX">TX</option>
                                        <option value="UT">UT</option>
                                        <option value="VA">VA</option>
                                        <option value="VT">VT</option>
                                        <option value="WA">WA</option>
                                        <option value="WV">WV</option>
                                        <option value="WI">WI</option>
                                        <option value="WY">WY</option>
                                    </select></p>
                            </div>	
                            <div id="zip-input" class="small-12 medium-3 large-4 cell">
                                <p><label for="zip">Zip:</label>
                                    <input id="zip" type="text" name="zipcode" v-model="contact.zipcode"></p>
                            </div>
                        </div>
                    </div>
                    <p><label for="request" style="font-size:16px;font-weight:700">Nature of your request, please describe in detail: <span style="font-size: 14px">(Maximum 1,500 characters)</span></label>
                        <textarea rows="5" maxlength="1500" id="request" name="request" v-model="contact.request"></textarea></p>
                    <p>
                        <label for="files">Attach Files (PDF and JPG only):</label>
                        <input id="files" ref="filePicker" type="file" name="files" @input="updateFiles" multiple accept="image/jpeg,application/pdf">
                        <a href="#" @click.prevent="showPicker" style="text-decoration: underline">Choose File(s)</a>
                    </p>
                    <p v-if="files.length > 0">Files added:</p>
                    <div class="file-item" v-for="(f, index) in files" :key="index">
                        <p>{{ f.name }} <a href="#" @click.prevent="deleteItem(index)">&times;</a></p>
                    </div>
                </div>
                <div class="small-12 cell">
                    <button type="submit" class="btn">Submit Form</button>
                </div>
            </div>
            <div class="grid-x grid-padding-x">
                <div class="small-12 cell">
                    <p>
                        <strong>Mailing Address:</strong><br>
                        WSFS Bank, Attn: Corporate Trust<br>
                        500 Delaware Ave, 11<sup>th</sup> Floor <br>
                        Wilmington, DE 19801
                    </p>
                </div>
            </div>
        </div>
    </main>
</form>
</template>
<script>
import axios from 'axios';


const max_filesize = 10*1024*1024;

export default {
    name: 'contact-form',
    data() {
        return {
            contact: {
                description: '',
                state: '',
            },
            files: [],
        }
    },
    computed: {
        totalsize() {
            let sum = 0;
            for (let f of this.files) {
                sum += f.size
            }

            return sum
        },
    },
    methods: {
        async submit() {
            if (this.totalsize > max_filesize) {
                return;
            }
            
            this.$el.page_submitted.value = Date.now()
            let data = new FormData(this.$el)
            data.delete('files')

            for (let fp of this.files) {
                data.append('upload', fp);
            }

            let r = await axios({
                method: 'post',
                url: '/api/send-message',
                data: data,
                config: { headers: {'Content-Type': 'multipart/form-data' }},
            })


            if (r.status != 200) {
                return;
            }
            
            location.href = '/thank-you.html';
        },
        updateFiles(event) {
            this.files = this.files.concat(Array.from(event.target.files))
        },
        showPicker() {
            this.$refs.filePicker.click()
        },
        deleteItem(index) {
            this.files.splice(index, 1)
        }
    },
    mounted() {
        this.$el.page_loaded.value = Date.now()
    },
}
</script>
<style lang="scss">
#contact-form input[type=file] {
    display: none;
}
</style>
